import { SkimLinks } from 'components/widget/skimlinks/skimlinks'
export default SkimLinks
